export enum EVersionsPerm {
    VERSIONS_DELETE = 'versions_delete',
    VERSIONS_EDIT = 'versions_edit',
    VERSIONS_VIEW = 'versions_view'
}
